import axios from '@/libs/axios'
import { ApiCode, ApiPartnersRoutes } from '@/const/api'
import { handleCatch } from '@/utils'

export const baseAttr = Object.freeze({
  basePath: ApiPartnersRoutes.lessonLog,
})

export default {
  namespaced: true,

  state: {
    resourceName: {
      fullName: 'Sổ lên lớp',
      shortName: 'SLL',
    },

    lessonLogs: [],
    total: 0,
    creditClasses: [],
  },

  getters: {
    resourceName: state => state.resourceName,
    lessonLogs: state => state.lessonLogs,
    total: state => state.total,
    creditClasses: state => state.creditClasses,
  },

  mutations: {

    SET_LESSON_LOGS: (state, data) => {
      state.lessonLogs = data
    },

    SET_TOTAL_ROWS: (state, total) => {
      state.total = total
    },

    SET_CREDIT_CLASSES: (state, data) => {
      state.creditClasses = data
    },

  },

  actions: {
    async readLessonLogs({ commit }, params) {
      try {
        const response = await axios.get(
          `${baseAttr.basePath}/getLessonLogs`,
          { params },
        )

        const { data } = response

        if (data.code === ApiCode.SUCCESS) {
          const { records, total } = data.data

          commit('SET_LESSON_LOGS', records)
          commit('SET_TOTAL_ROWS', total)
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    async getTeacherCreditClasses({ commit }, params) {
      try {
        const response = await axios.get(
          `${baseAttr.basePath}/getTeacherCreditClasses`,
          { params },
        )

        const { data } = response

        if (data.code === ApiCode.SUCCESS) {
          commit('SET_CREDIT_CLASSES', data.data)
        }
      } catch (e) {
        handleCatch(e)
      }
    },

    async createLessonLog(_, params) {
      try {
        const response = await axios.post(
          `${baseAttr.basePath}/create`,
          params,
        )

        const { data } = response

        return {
          isSuccessful: data.code === ApiCode.SUCCESS,
          message: data.message,
        }
      } catch (e) {
        handleCatch(e)
      }

      return null
    },

    async updateLessonLog(_, params) {
      try {
        const response = await axios.put(
          `${baseAttr.basePath}/update`,
          params,
        )

        const { data } = response

        return {
          isSuccessful: data.code === ApiCode.SUCCESS,
          message: data.message,
        }
      } catch (e) {
        handleCatch(e)
      }

      return null
    },
    async deleteLessonLog(_, id) {
      try {
        const response = await axios.delete(
          `${baseAttr.basePath}/delete/${id}`,
        )

        const { data } = response

        return {
          isSuccessful: data.code === ApiCode.SUCCESS,
          message: data.message,
        }
      } catch (e) {
        handleCatch(e)
      }

      return null
    },

    // export word
    async exportWord(_, params) {
      try {
        const response = await axios.get(
          `${baseAttr.basePath}/exportWordLessonLog`,
          {
            params,
            responseType: 'blob',
          },
        )

        const blob = new Blob([response.data])

        const url = window.URL.createObjectURL(blob)

        const link = document.createElement('a')

        link.href = url
        link.download = 'SoLenLop.docx'

        document.body.appendChild(link)

        link.click()

        link.remove()

        window.URL.revokeObjectURL(url)
      } catch (e) {
        handleCatch(e)
      }
    },

  },
}
